import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/paymentOptions', request)
}

export {get}
